import {componentCaller} from "./index";

const renderBanner = bannerData => bannerData && componentCaller(Object.keys(bannerData)[0], bannerData[Object.keys(bannerData)[0]]);

export default renderBanner;